module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "bg-gray"
  }, [_c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticClass: "form-content"
  }, [_c('el-form', {
    ref: "ruleForm",
    staticClass: "demo-ruleForm",
    attrs: {
      "model": _vm.row,
      "label-width": "100px"
    }
  }, [_c('div', {
    staticClass: "order-success"
  }, [_c('div', {
    staticClass: "icon"
  }), _vm._v(" "), _c('div', {
    staticClass: "title"
  }, [_vm._v("报名成功")]), _vm._v(" "), _c('div', {
    staticClass: "desc"
  }, [_c('p', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v("【重要】请仔细阅读下列说明")]), _vm._v(" "), _c('p', [_vm._v("1、报名成功后，请务必添加下方培训专属群！")]), _vm._v(" "), _c('p', [_vm._v("加群方式：群二维码截图-打开微信-扫一扫-相册-选择保存的群二维码图片即可")]), _vm._v(" "), _c('p', [_vm._v("\n            2、本次培训含有线上培训内容，啦啦之星平台为指定培训课程平台，请用微信扫描下课程兑换码（本码仅限观看课程《全国啦啦操新周期培训课程》，并非啦啦之星VIP年费会员），方可开始学习；注意：请在有效期内兑换，请用本人微信扫码兑换，一人一码，任何转借、外发，恕不再补；")])])]), _vm._v(" "), _c('el-row', [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "单位："
    }
  }, [_c('div', [_vm._v(_vm._s(_vm.row.danwei))])])], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "场次："
    }
  }, [_c('div', [_vm._v(_vm._s(_vm.row.station_name))])])], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "时间："
    }
  }, [_c('div', [_vm._v(_vm._s(_vm.row.station.startdate + '至' + _vm.row.station.enddate))])])], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "地点："
    }
  }, [_c('div', [_vm._v(_vm._s(_vm.row.station.province + '  ' + _vm.row.station.city + ' ' + _vm.row.station.county))])])], 1)], 1), _vm._v(" "), (_vm.row.learn_erweima) ? _c('div', {
    staticClass: "order-success"
  }, [(_vm.row.erweiimg.length > 0) ? _c('p', [_vm._v("扫码进入小程序,在线学习")]) : _vm._e(), _vm._v(" "), _c('img', {
    attrs: {
      "src": _vm.row.learn_erweima
    }
  })]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "order-success"
  }, [(_vm.row.erweiimg.length > 0) ? _c('img', {
    attrs: {
      "src": _vm.row.erweiimg[0].url
    }
  }) : _vm._e(), _vm._v(" "), (_vm.row.erweiimg.length > 0) ? _c('p', [_vm._v("扫码加工作人员好友，进入培训微信群")]) : _vm._e()]), _vm._v(" "), _c('el-row', [_c('el-col', {
    staticClass: "footer-button"
  }, [_c('el-button', {
    attrs: {
      "round": ""
    },
    on: {
      "click": function($event) {
        return _vm.goFiles(1)
      }
    }
  }, [_vm._v("培训通知下载")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "round": ""
    },
    on: {
      "click": function($event) {
        return _vm.goFiles(2)
      }
    }
  }, [_vm._v("导师团")]), _vm._v(" "), _c('el-button', {
    directives: [{
      name: "rblink",
      rawName: "v-rblink",
      value: ({
        name: 'HuiyiApplyList'
      }),
      expression: "{name:'HuiyiApplyList'}"
    }],
    attrs: {
      "type": "primary",
      "round": ""
    }
  }, [_vm._v("我的报名记录\n          ")])], 1)], 1)], 1)], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-75e448fe","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/page/apps/huiyi/HuiyiApplyFormSuccess.vue
// module id = 1487
// module chunks = 0